export default __webpack_public_path__ + "static/media/iosmobile.8c50a487.png";